import React from 'react';
import './ProgressBar.css';

/**
 * ProgressBar Component
 * Toont een voortgangsbalk met kleurcodering op basis van percentage
 * - Tot 70%: blauw
 * - 70-100%: geel/oranje
 * - >100%: rood
 */
const ProgressBar = ({ plannedTime, plannableTime }) => {
  // Bereken percentage (maximum 100% voor visuele weergave)
  let percentage = 0;
  if (plannableTime <= 0) {
    percentage = 100; // Geen plannable tijd, geen voortgangsbalk weergeven
  } else {
    percentage = Math.max(0, (plannedTime / plannableTime) * 100);
  }
  

  // Bepaal kleur op basis van percentage
  let barColor = 'blue';
  if (percentage >= 100) {
    barColor = 'green'; //red

    if (plannableTime <= 0) 
      barColor = 'gray'; // Geen plannable tijd, geen voortgangsbalk weergeven
  } 
  // else if (percentage >= 70) {
  //   barColor = 'orange';
  // }

  return (
    <div className="progress-bar-container">
      <div 
        className={`progress-bar progress-bar-${barColor}`} 
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
};

export default ProgressBar;
